import { ErrorHandler, Injectable } from '@angular/core';
import { PostHogService } from '../services/posthog.service';
import { StateService } from '../services/state.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private postHogService: PostHogService,
    private stateService: StateService
  ) {}

  handleError(error: any): void {
    // Log to console for development
    console.error('Global error caught:', error);

    // Get current user ID if available
    const currentUser = this.stateService.getCurrentUser();
    const userId = currentUser?._id || 'user_anonymous';

    // Prepare error properties
    const errorProperties = {
      url: window.location.href,
      user_agent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      component_stack: this.getComponentStack(error),
      zone: this.getZoneInfo(error)
    };

    // Capture error in PostHog
    this.postHogService.captureException(error, errorProperties);

    // Re-throw the error to maintain normal error handling behavior
    throw error;
  }

  /**
   * Extract component stack information if available
   */
  private getComponentStack(error: any): string {
    if (error?.ngDebugContext?.component) {
      return error.ngDebugContext.component.constructor.name;
    }
    return '';
  }

  /**
   * Extract zone information if available
   */
  private getZoneInfo(error: any): string {
    if (error?.ngDebugContext?.context) {
      return error.ngDebugContext.context.constructor.name;
    }
    return '';
  }
}
